export function updateObject(orgObject, objectWithUpdateValues) {
    for (let key in objectWithUpdateValues) {
        if (orgObject.hasOwnProperty(key)) {
            orgObject[key] = objectWithUpdateValues[key];
        }
    }
}